import { render } from "./Add.vue?vue&type=template&id=01d0a93c&ts=true"
import script from "./Add.vue?vue&type=script&lang=ts"
export * from "./Add.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__